import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api";
import { translations } from "../i18n";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, object=logged in
  const [lang, setLang] = useState(() => localStorage.getItem("dg_lang") || "en");
  const [site, setSite] = useState({});

  useEffect(() => {
    if (localStorage.getItem("dg_token")) {
      api.get("/auth/me")
        .then((r) => setUser(r.data))
        .catch(() => setUser(false));
    } else {
      setUser(false);
    }
    api.get("/settings/public").then((r) => setSite(r.data)).catch(() => {});
  }, []);

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("dg_lang", l);
    document.documentElement.lang = l === "gu" ? "gu" : "en";
  }, []);

  const t = useCallback((key) => translations[lang]?.[key] ?? translations.en[key] ?? key, [lang]);

  const login = (data) => {
    if (data?.token) localStorage.setItem("dg_token", data.token);
    const { token, ...u } = data || {};
    setUser(u);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("dg_token");
    setUser(false);
  };

  return (
    <AppContext.Provider value={{ user, setUser, login, logout, lang, changeLang, t, site }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
